/**
 * 選択されたロゴファイルからプレビュー用の<img>要素を生成する
 *
 * @param {HTMLTemplateElement} template
 * @param {string} object_url
 * @returns {HTMLImageElement}
 */
const build_preview_image = (template, object_url) => {
    const image = template.content.firstElementChild.cloneNode(true)
    image.src = object_url
    return image
}

/**
 * プレビューエリアの初期化
 *
 * ファイル選択時はブラウザ内でプレビュー画像に差し替え、選択解除時は初期状態
 * （登録済みロゴ表示 or 未選択メッセージ）に戻す。サーバーへの送信は行わない。
 *
 * @returns {void}
 */
const init_logo_preview = () => {
    const file_input = document.getElementById('logo-file-input')
    const preview_container = document.getElementById('logo-preview-container')
    const preview_template = document.getElementById('logo-preview-image-template')
    if (file_input === null || preview_container === null || preview_template === null) return

    const initial_html = preview_container.innerHTML
    let current_object_url = null

    file_input.addEventListener('change', () => {
        if (current_object_url !== null) {
            URL.revokeObjectURL(current_object_url)
            current_object_url = null
        }

        const file = file_input.files[0]
        if (!file) {
            preview_container.innerHTML = initial_html
            return
        }

        current_object_url = URL.createObjectURL(file)
        const image = build_preview_image(preview_template, current_object_url)

        preview_container.innerHTML = ''
        preview_container.appendChild(image)
    })
}

/**
 * ロゴ画像の読み込みに失敗した場合、壊れたアイコンを表示せず要素ごと非表示にする
 *
 * @returns {void}
 */
const init_logo_broken_image_fallback = () => {
    document.querySelectorAll('.js-organization-logo-image').forEach((image) => {
        image.addEventListener('error', () => {
            image.style.display = 'none'
        })
    })
}

/**
 * 「現在のロゴ」で画像読み込みに失敗した場合、エラーメッセージを表示する
 *
 * @returns {void}
 */
const init_current_logo_error_message = () => {
    const image = document.getElementById('organization-logo-current-image')
    const message = document.getElementById('organization-logo-current-image-error')
    if (image === null || message === null) return

    image.addEventListener('error', () => {
        message.hidden = false
    })
}

/**
 * 初期化
 *
 * @returns {void}
 */
const init_organization_logo = () => {
    init_logo_preview()
    init_logo_broken_image_fallback()
    init_current_logo_error_message()
}

document.addEventListener('DOMContentLoaded', init_organization_logo)
